import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { format } from "date-fns";

const formatToFirstDayOfMonth = (date: Date): Date => {
	const formatted = new Date(date);
	formatted.setDate(1);
	formatted.setHours(0, 0, 0, 0);
	return formatted;
};

export const getProcesss = async (month: Date, assetId: number | null) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	const formattedDate = format(formatToFirstDayOfMonth(month), "yyyy-MM-dd");

	parameters.push({
		name: "Month",
		value: formattedDate,
	});
	parameters.push({
		name: "AssetId",
		value: assetId || null,
	});

	const resp = await apiService.callV2(
		"[EAF].[GetProcessDataMonthlyReport]",
		parameters,
	);
	return resp;
};
